import _sfc_main from "./Option.vue2.js";
/* empty css            */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Option = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-67782e43"]]);
export {
  Option as default
};
//# sourceMappingURL=Option.vue.js.map
